import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/config-service/app.config';

@Component({
  selector: 'app-download-app',
  templateUrl: './download-app.component.html',
  styleUrls: ['./download-app.component.css']
})
export class DownloadAppComponent implements OnInit {  
  public androidQRSrc: string = '';
  public iosQRSrc: string = '';

  constructor(private translate: TranslateService) { 
    if(AppConfig.settings.imageSource && AppConfig.settings.imageSource.androidAppDownloadQR){
      this.androidQRSrc = AppConfig.settings.imageSource.androidAppDownloadQR;
    }
    if(AppConfig.settings.imageSource && AppConfig.settings.imageSource.iosAppDownloadQR){
      this.iosQRSrc = AppConfig.settings.imageSource.iosAppDownloadQR;
    }
  }
    
  ngOnInit(): void {
  }

}
